import {
  isCustomNodeSelected,
  isTextSelected,
} from "@components/tiptapEditor/utils";
import { Editor } from "@tiptap/react";
import { useCallback } from "react";
import { ShouldShowProps } from "../../types";

export const useTextmenuStates = (editor: Editor | null) => {
  const shouldShow = useCallback(
    ({ view, from }: ShouldShowProps) => {
      if (!view || !editor) {
        return false;
      }

      const domAtPos = view.domAtPos(from || 0).node as HTMLElement;
      const nodeDOM = view.nodeDOM(from || 0) as HTMLElement;
      const node = nodeDOM || domAtPos;

      if (isCustomNodeSelected(editor, node)) {
        return false;
      }

      return isTextSelected({ editor });
    },
    [editor]
  );

  return {
    isBold: editor?.isActive("bold") || false,
    isItalic: editor?.isActive("italic") || false,
    isStrike: editor?.isActive("strike") || false,
    isUnderline: editor?.isActive("underline") || false,
    isCode: editor?.isActive("code") || false,
    isSubscript: editor?.isActive("subscript") || false,
    isSuperscript: editor?.isActive("superscript") || false,
    isAlignLeft: editor?.isActive({ textAlign: "left" }) || false,
    isAlignCenter: editor?.isActive({ textAlign: "center" }) || false,
    isAlignRight: editor?.isActive({ textAlign: "right" }) || false,
    isAlignJustify: editor?.isActive({ textAlign: "justify" }) || false,
    currentColor: editor?.getAttributes("textStyle")?.color || undefined,
    currentHighlight: editor?.getAttributes("highlight")?.color || undefined,
    currentFont: editor?.getAttributes("textStyle")?.fontFamily || undefined,
    currentSize: editor?.getAttributes("textStyle")?.fontSize || undefined,
    shouldShow,
  };
};
